import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'referencesType';

export class ReferencesType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
